var map = {
  "./heros/hero-homepage/hero-homepage.js": [
    "318",
    [
      899
    ]
  ],
  "./components/shares/shares.js": [
    "785",
    [
      440
    ]
  ],
  "./strates/strate-our_foundations/strate-our_foundations.js": [
    "353",
    [
      166
    ]
  ],
  "./strates/strate-platform/strate-platform.js": [
    "625",
    [
      386
    ]
  ],
  "./components/accordion/accordion.js": [
    "575",
    [
      510
    ]
  ],
  "./components/slider/slider.js": [
    "751",
    [
      762
    ]
  ],
  "./components/slideshow/slideshow.js": [
    "15",
    [
      362
    ]
  ],
  "./components/video/video.js": [
    "303",
    [
      350
    ]
  ],
  "./common/footer/footer.js": [
    "918",
    [
      897
    ]
  ],
  "./strates/strate-key_people/strate-key_people copy.js": [
    "60",
    [
      194
    ]
  ],
  "./strates/strate-showcase/strate-showcase.js": [
    "709",
    [
      522
    ]
  ],
  "./strates/strate-toolkit/strate-toolkit.js": [
    "740",
    [
      984
    ]
  ],
  "./common/header-nav/header-nav.js": [
    "110",
    [
      61
    ]
  ],
  "./components/select-lang/select-lang.js": [
    "359",
    [
      486
    ]
  ],
  "./strates/strate-key_people/strate-key_people.js": [
    "913",
    [
      458
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 526;
module.exports = __rspack_async_context;
